import { useTranslation } from "react-i18next";
import React, { useState, useEffect, Fragment, useRef } from "react";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import apiRequest from "../../functions/api";
import WarningIcon from "@mui/icons-material/Warning";
import InfoIcon from "@mui/icons-material/Info";
import {
  Typography,
  Grid,
  Button,
  TextField,
  MenuItem,
  CircularProgress,
  Box,
  InputAdornment,
  ListItemAvatar,
  Alert,
  Card,
  CardContent,
  IconButton,
  ListItemButton,
  Divider,
  Tooltip,
  Checkbox,
  FormControlLabel,
  FormControl,
  FormLabel,
} from "@mui/material";
import LoadingComponent from "../LoadingComponent/LoadingComponent";
import { useMessage } from "../../context/message-context";
import Autocomplete from "@mui/material/Autocomplete";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import Brightness1Icon from "@mui/icons-material/Brightness1";
import { useSessionStorage } from "../../utils/hooks";
import { LOCAL_STORAGE_KEY } from "../../constants/localStorage";
import { DateTextField, FullPageSpinner } from "../lib";
import Edit from "@mui/icons-material/Edit";
import Page from "../shared/components/PageComponent";
import Layout from "../shared/components/LayoutComponent";
import MessageBox from "../shared/components/MessageBox";
import StrassenAutocomplete from "../StrassenAutocomplete/StrassenAutocomplete";

function Stammformular(props) {
  const { t } = useTranslation();
  let { stammid } = useParams();
  //  const forceUpdate = useCallback(() => updateState({}), []);
  const [isLoading, setIsLoading] = useState(true);
  const { hideMessage, showErrorMessage } = useMessage();
  const { client } = props;
  const [menubuttons, setMenuButtons] = useState([]);
  const [auswahlKey, setAuswahlKey] = useState(0);
  const [orte, setOrte] = useState([]);
  const [strasse, setStrasse] = useState([]);
  const [krankenkasse, setKrankenkasse] = useState([]);
  const [issending, setIsSending] = useState(false);
  const [gbort, setGbOrt] = useState([]);
  const [accessToken] = useSessionStorage(LOCAL_STORAGE_KEY.accessToken);
  const [hmnpunkte, setHMNPunkte] = useState([]);
  const [vollstaendig, setVollstaendig] = useState("0");
  const [farbe_fertig, setFarbeFertig] = useState("076, 175, 080");
  const [farbe_error, setFarbeError] = useState("244, 067, 054");
  const [farbe_optional, setFarbeOptional] = useState("033, 150, 243");
  const [svcheck, setSVCheck] = useState("0");
  const [svcheckfarbe, setSVCheckFarbe] = useState("");
  const navigate = useNavigate();
  const [erneut, setErneut] = useState(false);
  const [checkedError, setCheckedError] = useState(false);
  const [checked, setChecked] = useState(false);
  const [ticketkey, setTicketKey] = useState(stammid ? stammid : "");
  const [ticketclient, setTicketClient] = useState(client ? client : "");
  const [land, setLand] = useState("   ");
  const [plzIsLoading, setPlzIsLoading] = useState(false);
  const [pruefen, setPruefen] = useState(false);
  const [lfd, setLfd] = useState();
  const [daten, setDaten] = useState();
  const [warningMsgbox, setWarningMsgbox] = useState();
  const location = useLocation();
  const [initModal, setInitModal] = useState(true);
  const programm = location?.state?.programm ? location.state.programm : "STAMBO";
  const delayInputTimeoutId = useRef(0);

  useEffect(() => {
    holeStammblatt();
  }, []);

  useEffect(() => {
    if (pruefen) abgabePruefen();
  }, [pruefen]);

  const abgabePruefen = () => {
    setIsLoading(true);
    const payload = {
      program: "STAMBO",
      statement: "PRUEFE_ABGABE",
      stammid: ticketkey,
      client: ticketclient,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "stambo", payload, headers, pruefeCb, errorcB);
  };

  const pruefeCb = (response) => {
    setPlzIsLoading(false);
    setIsLoading(false);
    if (response.status === 200) {
      setDaten(response.data.menu);
      setErneut(false);
      setVollstaendig(response.data.vollstaendig);
      hideMessage();
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };

  const holeStammblatt = () => {
    setIsLoading(true);
    const payload = {
      program: programm,
      statement: "HOLE_STAMMBLATT",
      stammid: ticketkey,
      client: ticketclient,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "stambo", payload, headers, menuCb, errorcB);
    setAuswahlKey(0);
  };
  const errorcB = () => {
    setErneut(true);
    showErrorMessage(t("Keine Internetverbindung. Bitte erneut versuchen"));
  };

  const menuCb = (response) => {
    setPlzIsLoading(false);
    setIsLoading(false);
    if (response.status === 200) {
      if (response.data.fehler) {
        showErrorMessage(response.data.fehler);
      }
      setErneut(false);
      if (response.data.orte) {
        setOrte(response.data.orte);
      }
      if (response.data.strasse) {
        setStrasse(response.data.strasse);
      }
      if (response.data.kk) {
        setKrankenkasse(response.data.kk);
      }

      if (response.data.gort) {
        setGbOrt(response.data.gort);
      }
      if (response.data.land) {
        setLand(response.data.land);
      }
      if (response.data.stammid) {
        setTicketKey(response.data.stammid);
      }
      if (response.data.client) {
        setTicketClient(response.data.client);
      }
      if (response.data.sv_start === "1") {
        navigate("/interview/IVECSV", {
          state: {
            programm: programm,
            uebergaben: { "LPB1-KEY": response.data.stammid },
          },
        });
      }

      let temp_daten = [];
      temp_daten.push({ lfd: "00", bez: "Hauptmenü" });
      const setzte_menu = response.data.menu
        .filter((element) => element.key === "00")
        .map((element, count) => {
          return { lfd: element.lfd, bez: element.bez };
        });
      Array.prototype.push.apply(temp_daten, setzte_menu);

      setHMNPunkte(temp_daten);
      setMenuButtons(response.data.menu);
      setIsLoading(false);
      setVollstaendig(response.data.vollstaendig);
      setFarbeFertig(response.data.farbe_voll);
      setFarbeError(response.data.farbe_unvoll);
      setFarbeOptional(response.data.farbe_optional);
      setSVCheck(response.data.sv_check);
      setSVCheckFarbe(response.data.sv_check_farbe);
      // hideMessage();
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };
  const kkCb = (response) => {
    setIsSending(false);
    if (response.status === 200) {
      if (response.data.kk) {
        setKrankenkasse(response.data.kk);
      }
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };
  const gbCb = (response) => {
    setIsSending(false);
    if (response.status === 200) {
      if (response.data.gort) {
        setGbOrt(response.data.gort);
      }
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };
  const siCb = (response) => {
    setIsSending(false);
    if (response.status === 200) {
      window.location.reload();
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };
  
  function schreibeAntwort(punkt_key, punkt_lfd, punkt_antwort, punkt_datum) {
    const payload = {
      program: programm,
      statement: "SCHREIBE_WERT",
      key: punkt_key,
      lfd: punkt_lfd,
      antwort: punkt_antwort,
      datum: punkt_datum,
      stammid: ticketkey,
      client: ticketclient,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "stambo", payload, headers, menuCb, errorcB);
  }

  const hole_kk = (value) => {
    setIsSending(true);
    const payload = {
      program: programm,
      statement: "PRUEFE_KK",
      ik: value,
      stammid: ticketkey,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };

    apiRequest("POST", "stambo", payload, headers, kkCb, errorcB);
  };
  const pruefe_kk = (kk_value) => {
      clearTimeout(delayInputTimeoutId.current);
    if (kk_value.length > 2 && isNaN(kk_value)) {
      delayInputTimeoutId.current = setTimeout(() => {
        hole_kk(kk_value.slice(0, 3));
      }, 500);
    }
    if (kk_value.length > 4 && !isNaN(kk_value)) {
      delayInputTimeoutId.current = setTimeout(() => {
        hole_kk(kk_value);
      }, 500);
    }
    if (kk_value.length < 5 && !isNaN(kk_value)) {
      setKrankenkasse([]);
    }
    if (kk_value.length < 3 && isNaN(kk_value)) {
      setKrankenkasse([]);
    }
  };
  const hole_gbort = (value) => {
    setIsSending(true);
    const payload = {
      program: programm,
      statement: "PRUEFE_GBORT",
      suche: value,
      stammid: stammid,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "stambo", payload, headers, gbCb, errorcB);
  };
  const pruefe_gbort = (fragenr, gb_value) => {
    if (gb_value.length > 2 && gbort.length === 0) {
      hole_gbort(gb_value.slice(0, 3));
    }
    if (gb_value.length < 3) {
      setGbOrt([]);
    }
  };
  const signatur = () => {
    setIsSending(true);
    const payload = {
      program: programm,
      statement: "SIGNATUR",
      stammid: ticketkey,
      client: ticketclient,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "stambo", payload, headers, siCb, errorcB);
  };
  const setze_eingabe_antwort = (fragenkey, fragenlfd, value, feld) => {
    var frage = menubuttons.find((element) => element.lfd === fragenlfd && element.key === fragenkey);
    var fragennr = menubuttons.indexOf(frage);
    var temp_daten = menubuttons.slice();
    temp_daten[fragennr]["antwort"] = value;
    if (value !== "") {
      temp_daten[fragennr]["antwort_vorhanden"] = "1";
    } else {
      temp_daten[fragennr]["antwort_vorhanden"] = "0";
    }
    setMenuButtons(temp_daten);

    if (feld && feld === "LPB1-PLZ") {
      if (value.length > 4 && land === "   ") {
        setPlzIsLoading(true);
        schreibeAntwort(fragenkey, fragenlfd, value, "");
      }
    }
  };

  if (erneut) {
    return (
      <Fragment>
        <Grid container justifyContent="center">
          <Grid item xs={12} sm={6}>
            <Grid container justifyContent="flex-start" spacing={2} alignItems="center">
              <Grid item xs={12}>
                <Typography variant="h6">{t("Es ist ein Fehler beim Laden des Stammblattes aufgetreten")}</Typography>
              </Grid>
              <Grid item xs={12}>
                <Button fullWidth color="primary" variant="contained" onClick={() => holeStammblatt()}>
                  {t("Erneut versuchen")}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Fragment>
    );
  }
  if (isLoading) {
    return <LoadingComponent />;
  }

  const drawMenubuttons =
    menubuttons.length > 0 &&
    menubuttons
      .filter((element) => element.key === hmnpunkte[auswahlKey]?.lfd)
      .map((element, count) => {
        if (auswahlKey === 0) {
          return (
            <Box sx={{ width: "100%" }}>
              <Divider />
              <ListItemButton divider onClick={() => nextSection(count + 1)}>
                <ListItemAvatar>
                  {element.farbe === farbe_fertig ? (
                    <CheckCircleOutlineIcon style={{ color: "rgba(" + element.farbe + " ,0.8)" }} />
                  ) : element.farbe === farbe_optional ? (
                    <Brightness1Icon style={{ color: "rgba(" + element.farbe + " ,0.8)" }} />
                  ) : (
                    <ErrorOutlineIcon style={{ color: "rgba(" + element.farbe + " ,0.8)" }} />
                  )}
                </ListItemAvatar>
                <div
                  style={{
                    display: "flex",
                    direction: "row",
                    width: "100%",
                    justifyContent: "space-between",
                  }}
                >
                  {element.bez}
                  <ArrowForwardIosIcon fontSize="small" />
                </div>
              </ListItemButton>
            </Box>
          );
        } else {
          if (element.art === "AUTOCOMP") {
            if (element.feld === "LPB1-WOHNORT") {
              return (
                <Fragment>
                  <Grid item xs={12}>
                    <TextField
                      key={element.key}
                      label={element.bez}
                      align="left"
                      select
                      helperText={element.hilfe !== "" && element.hilfe.length < 400 && element.hilfe}
                      variant="outlined"
                      fullWidth
                      value={element.antwort_vorhanden === "1" ? element.antwort : ""}
                      error={element.antwort_vorhanden === "0" && element.optional === "0"}
                      onChange={(event) => schreibeAntwort(element.key, element.lfd, event.target.value, element.datum)}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            {element.antwort_vorhanden === "1" && element.optional === "0" ? (
                              <CheckCircleOutlineIcon
                                style={{
                                  color: "rgba(" + farbe_fertig + " ,0.8)",
                                }}
                              />
                            ) : element.optional === "1" ? (
                              <Brightness1Icon
                                style={{
                                  color: "rgba(" + farbe_optional + " ,0.8)",
                                }}
                              />
                            ) : (
                              <ErrorOutlineIcon
                                style={{
                                  color: "rgba(" + farbe_error + " ,0.8)",
                                }}
                              />
                            )}
                          </InputAdornment>
                        ),
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    >
                      {orte.map((mehr_orte) => {
                        return <MenuItem value={mehr_orte.ort}>{mehr_orte.ort}</MenuItem>;
                      })}
                    </TextField>
                  </Grid>
                </Fragment>
              );
            }
            if (element.feld === "LPB1-STRASSE") {
              return (
                <Grid item xs={12}>
                  <StrassenAutocomplete
                    isOptionEqualToValue={(option, value) => option.suchstrasse === value.suchstrasse}
                    autoFocus={element.lfd === lfd}
                    // SelectProps={{ open: element.lfd === lfd }}
                    key={element.key}
                    noOptionsText={t("kein Eintrag gefunden")}
                    onChange={(event, newValue) => {
                      newValue !== null
                        ? schreibeAntwort(element.key, element.lfd, newValue.strasse, element.datum)
                        : schreibeAntwort(element.key, element.lfd, "", element.datum);
                    }}
                    options={strasse}
                    getOptionLabel={(option) => option.strasse}
                    value={strasse.find((antwort) => antwort.strasse === element.antwort) || null}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={element.bez}
                        variant="outlined"
                        error={element.antwort_vorhanden === "0"}
                        helperText={element.hilfe !== "" && element.hilfe.length < 400 && element.hilfe}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                          ...params.InputProps,
                          startAdornment: (
                          <InputAdornment position="start">
                            {element.antwort_vorhanden === "1" && element.optional === "0" ? (
                              <CheckCircleOutlineIcon
                                style={{
                                  color: "rgba(" + farbe_fertig + " ,0.8)",
                                }}
                              />
                            ) : element.optional === "1" ? (
                              <Brightness1Icon
                                style={{
                                  color: "rgba(" + farbe_optional + " ,0.8)",
                                }}
                              />
                            ) : (
                              <ErrorOutlineIcon
                                style={{
                                  color: "rgba(" + farbe_error + " ,0.8)",
                                }}
                              />
                            )}
                            </InputAdornment>
                          ),
                        }}
                      />
                    )}
                  />
                </Grid>
              );
            }
            if (element.feld === "LPB1-KK_IK") {
              return (
                <Grid item xs={12}>
                  <Autocomplete
                    autoFocus={element.lfd === lfd}
                    // SelectProps={{ open: element.lfd === lfd }}
                    key={element.key}
                    noOptionsText={t("kein Eintrag gefunden")}
                    onChange={(event, newValue) => {
                      newValue !== null ? schreibeAntwort(element.key, element.lfd, newValue.key, "") : schreibeAntwort(element.key, element.lfd, "", "");
                    }}
                    loading={issending}
                    onInputChange={(event, newValue) => {
                      pruefe_kk(newValue);
                    }}
                    options={krankenkasse}
                    getOptionLabel={(option) => option.bez}
                    defaultValue={krankenkasse.find((antwort) => antwort.key === element.antwort) || null}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={element.bez}
                        variant="outlined"
                        error={element.antwort_vorhanden === "0"}
                        helperText={element.hilfe !== "" && element.hilfe.length < 400 && element.hilfe}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <Fragment>
                              {issending ? <CircularProgress color="inherit" size={20} /> : null}
                              {params.InputProps.endAdornment}
                            </Fragment>
                          ),
                          startAdornment: (
                            <InputAdornment position="start">
                              {element.antwort_vorhanden === "1" && element.optional === "0" ? (
                                <CheckCircleOutlineIcon
                                  style={{
                                    color: "rgba(" + element.farbe + " ,0.8)",
                                  }}
                                />
                              ) : element.optional === "1" ? (
                                <Brightness1Icon
                                  style={{
                                    color: "rgba(" + element.farbe + " ,0.8)",
                                  }}
                                />
                              ) : (
                                <ErrorOutlineIcon
                                  style={{
                                    color: "rgba(" + element.farbe + " ,0.8)",
                                  }}
                                />
                              )}
                            </InputAdornment>
                          ),
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    )}
                  />
                </Grid>
              );
            }
            if (element.feld === "LPB1-ORTKEY") {
              return (
                <Grid item xs={12}>
                  <Autocomplete
                    autoFocus={element.lfd === lfd}
                    // SelectProps={{ open: element.lfd === lfd }}
                    key={element.key}
                    noOptionsText={t("kein Eintrag gefunden")}
                    onChange={(event, newValue) => {
                      newValue !== null ? schreibeAntwort(element.key, element.lfd, newValue.key, "") : schreibeAntwort(element.key, element.lfd, "", "");
                    }}
                    loading={issending}
                    onInputChange={(event, newValue) => {
                      pruefe_gbort(count, newValue);
                    }}
                    options={gbort}
                    getOptionLabel={(option) => option.anzeige}
                    defaultValue={gbort.find((antwort) => antwort.key === element.antwort) || null}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={element.bez}
                        variant="outlined"
                        error={element.antwort_vorhanden === "0"}
                        helperText={element.hilfe !== "" && element.hilfe.length < 400 && element.hilfe}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <Fragment>
                              {issending ? <CircularProgress color="inherit" size={20} /> : null}
                              {params.InputProps.endAdornment}
                            </Fragment>
                          ),
                          startAdornment: (
                            <InputAdornment position="start">
                              {element.antwort_vorhanden === "1" && element.optional === "0" ? (
                                <CheckCircleOutlineIcon
                                  style={{
                                    color: "rgba(" + element.farbe + " ,0.8)",
                                  }}
                                />
                              ) : element.optional === "1" ? (
                                <Brightness1Icon
                                  style={{
                                    color: "rgba(" + element.farbe + " ,0.8)",
                                  }}
                                />
                              ) : (
                                <ErrorOutlineIcon
                                  style={{
                                    color: "rgba(" + element.farbe + " ,0.8)",
                                  }}
                                />
                              )}
                            </InputAdornment>
                          ),
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    )}
                  />
                </Grid>
              );
            }
            return (
              <Grid item xs={12}>
                <Typography variant="body1">{t("Unbekannt")}</Typography>
              </Grid>
            );
          } else if (element.art === "INFO") {
            return (
              <Grid item xs={12}>
                <Alert color="info">{element.bez}</Alert>
              </Grid>
            );
          } else {
            return (
              <Fragment>
                <Grid item xs={12}>
                  {element.auswahl === "0" && element.datum !== "0" && (
                    <DateTextField
                      autoFocus={element.lfd === lfd}
                      key={element.key}
                      disabled={element.art === "TEXT"}
                      label={element.bez}
                      variant="outlined"
                      fullWidth
                      value={element.antwort_vorhanden === "1" ? element.antwort : ""}
                      error={element.antwort_vorhanden === "0" && element.optional === "0"}
                      helperText={element.hilfe !== "" && element.hilfe.length < 400 && element.hilfe}
                      onKeyDown={(taste) => taste.key === "Enter" && taste.target.blur()}
                      onChange={(event) => setze_eingabe_antwort(element.key, element.lfd, event.target.value, element.feld)}
                      onBlur={(event) => schreibeAntwort(element.key, element.lfd, element.antwort, element.datum)}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            {element.antwort_vorhanden === "1" && element.optional === "0" ? (
                              <CheckCircleOutlineIcon
                                style={{
                                  color: "rgba(" + element.farbe + " ,0.8)",
                                }}
                              />
                            ) : element.optional === "1" ? (
                              <Brightness1Icon
                                style={{
                                  color: "rgba(" + element.farbe + " ,0.8)",
                                }}
                              />
                            ) : (
                              <ErrorOutlineIcon
                                style={{
                                  color: "rgba(" + element.farbe + " ,0.8)",
                                }}
                              />
                            )}
                          </InputAdornment>
                        ),
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  )}
                  {element.auswahl === "0" && element.datum === "0" && (
                    <TextField
                      autoFocus={element.lfd === lfd}
                      key={element.key}
                      disabled={element.art === "TEXT"}
                      label={element.bez}
                      variant="outlined"
                      fullWidth
                      value={element.antwort_vorhanden === "1" ? element.antwort : ""}
                      error={element.antwort_vorhanden === "0" && element.optional === "0"}
                      helperText={element.hilfe !== "" && element.hilfe.length < 400 && element.hilfe}
                      onKeyDown={(taste) => taste.key === "Enter" && taste.target.blur()}
                      onChange={(event) => setze_eingabe_antwort(element.key, element.lfd, event.target.value, element.feld)}
                      onBlur={(event) => schreibeAntwort(element.key, element.lfd, element.antwort, element.datum)}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            {element.antwort_vorhanden === "1" && element.optional === "0" ? (
                              <CheckCircleOutlineIcon
                                style={{
                                  color: "rgba(" + element.farbe + " ,0.8)",
                                }}
                              />
                            ) : element.optional === "1" ? (
                              <Brightness1Icon
                                style={{
                                  color: "rgba(" + element.farbe + " ,0.8)",
                                }}
                              />
                            ) : (
                              <ErrorOutlineIcon
                                style={{
                                  color: "rgba(" + element.farbe + " ,0.8)",
                                }}
                              />
                            )}
                          </InputAdornment>
                        ),
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  )}
                  {element.auswahl === "1" && (
                    <TextField
                      autoFocus={element.lfd === lfd}
                      key={element.key}
                      align="left"
                      label={element.bez}
                      select
                      variant="outlined"
                      fullWidth
                      value={element.antwort_vorhanden === "1" ? element.antwort : ""}
                      error={element.antwort_vorhanden === "0" && element.optional === "0"}
                      helperText={element.hilfe !== "" && element.hilfe.length < 400 && element.hilfe}
                      onChange={(event) => schreibeAntwort(element.key, element.lfd, event.target.value, element.datum)}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            {element.antwort_vorhanden === "1" && element.optional === "0" ? (
                              <CheckCircleOutlineIcon
                                style={{
                                  color: "rgba(" + element.farbe + " ,0.8)",
                                }}
                              />
                            ) : element.optional === "1" ? (
                              <Brightness1Icon
                                style={{
                                  color: "rgba(" + element.farbe + " ,0.8)",
                                }}
                              />
                            ) : (
                              <ErrorOutlineIcon
                                style={{
                                  color: "rgba(" + element.farbe + " ,0.8)",
                                }}
                              />
                            )}
                          </InputAdornment>
                        ),
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    >
                      {element.auswahltbl.map((antwort) => {
                        return <MenuItem value={antwort.key}>{antwort.text}</MenuItem>;
                      })}
                    </TextField>
                  )}
                  {element.auswahl === "2" && (
                    <Autocomplete
                      // autoFocus={element.lfd === lfd}
                      // openSelectProps={{ open: element.lfd === lfd }}
                      key={element.key}
                      noOptionsText={t("kein Eintrag gefunden")}
                      onChange={(event, newValue) => {
                        newValue !== null
                          ? schreibeAntwort(element.key, element.lfd, newValue.key, element.datum)
                          : schreibeAntwort(element.key, element.lfd, "", element.datum);
                      }}
                      options={element.auswahltbl}
                      getOptionLabel={(option) => option.text}
                      helperText={element.hilfe !== "" && element.hilfe.length < 400 && element.hilfe}
                      defaultValue={element.auswahltbl.find((antwort) => antwort.key === element.antwort) || null}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={element.bez}
                          variant="outlined"
                          error={element.antwort_vorhanden === "0" && element.optional === "0"}
                          helperText={element.hilfe !== "" && element.hilfe.length < 400 && element.hilfe}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            ...params.InputProps,
                            startAdornment: (
                              <InputAdornment position="start">
                                {element.antwort_vorhanden === "1" && element.optional === "0" ? (
                                  <CheckCircleOutlineIcon
                                    style={{
                                      color: "rgba(" + element.farbe + " ,0.8)",
                                    }}
                                  />
                                ) : element.optional === "1" ? (
                                  <Brightness1Icon
                                    style={{
                                      color: "rgba(" + element.farbe + " ,0.8)",
                                    }}
                                  />
                                ) : (
                                  <ErrorOutlineIcon
                                    style={{
                                      color: "rgba(" + element.farbe + " ,0.8)",
                                    }}
                                  />
                                )}
                              </InputAdornment>
                            ),
                          }}
                        />
                      )}
                    />
                  )}
                </Grid>
              </Fragment>
            );
          }
        }
      });

  const nextSection = (wert, lfd) => {
    setAuswahlKey(wert);
    setPruefen(false);
    if (lfd) setLfd(lfd);
  };

  const handleCheckChange = (e) => {
    if (e.target.checked) {
      setCheckedError(false);
    }
    setChecked(e.target.checked);
  };

  const zeichne_hauptseite = () => {
    return (
      <>
        <Layout>
          <Grid container justifyContent="flex-start" rowSpacing={2} alignItems="center" style={{ padding: "15px" }}>
            {hmnpunkte[auswahlKey] && (
              <Grid item xs={12}>
                <Typography variant="h6" color="primary">
                  {hmnpunkte[auswahlKey]?.bez}
                </Typography>
              </Grid>
            )}
            <Grid item xs={12}>
              <Grid container>
                <Grid item xs={12} md={6} lg={3}>
                  <Button
                    disabled
                    size="small"
                    startIcon={
                      <CheckCircleOutlineIcon
                        style={{
                          color: "rgba(" + farbe_fertig + " ,0.8)",
                        }}
                      />
                    }
                  >
                    {
                      <Typography
                        style={{
                          color: "rgba(" + farbe_fertig + " ,0.8)",
                        }}
                        variant="button"
                      >
                        {"= " + t("vollständig")}
                      </Typography>
                    }
                  </Button>
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                  <Button
                    disabled
                    startIcon={
                      <ErrorOutlineIcon
                        style={{
                          color: "rgba(" + farbe_error + " ,0.8)",
                        }}
                      />
                    }
                  >
                    {
                      <Typography
                        style={{
                          color: "rgba(" + farbe_error + " ,0.8)",
                        }}
                        variant="button"
                      >
                        {"= " + t("unvollständig")}
                      </Typography>
                    }
                  </Button>
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                  <Button
                    disabled
                    startIcon={
                      <Brightness1Icon
                        style={{
                          color: "rgba(" + farbe_optional + " ,0.8)",
                        }}
                      />
                    }
                  >
                    {
                      <Typography
                        style={{
                          color: "rgba(" + farbe_optional + " ,0.8)",
                        }}
                        variant="button"
                      >
                        {"= " + t("optional")}
                      </Typography>
                    }
                  </Button>
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                  <Button
                    startIcon={<InfoIcon />}
                    style={{
                      backgroundColor: "unset",
                    }}
                    onClick={() => setInitModal(true)}
                    color="primary"
                  >
                    {t("Hinweis anzeigen")}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
            {drawMenubuttons}
            {auswahlKey === 0 && svcheck === "1" && (
              <Grid xs={12}>
                <ListItemButton
                  divider
                  onClick={() =>
                    navigate("/interview/IVECSV", {
                      state: {
                        programm: programm,
                        uebergaben: { "LPB1-KEY": ticketkey },
                      },
                    })
                  }
                >
                  <ListItemAvatar>
                    {svcheckfarbe === "076, 175, 080" ? (
                      <CheckCircleOutlineIcon
                        style={{
                          color: "rgba(" + svcheckfarbe + " ,0.8)",
                        }}
                      />
                    ) : svcheckfarbe === "033, 150, 243" ? (
                      <Brightness1Icon
                        style={{
                          color: "rgba(" + svcheckfarbe + " ,0.8)",
                        }}
                      />
                    ) : (
                      <ErrorOutlineIcon
                        style={{
                          color: "rgba(" + svcheckfarbe + " ,0.8)",
                        }}
                      />
                    )}
                  </ListItemAvatar>
                  <div
                    style={{
                      display: "flex",
                      direction: "row",
                      width: "100%",
                      justifyContent: "space-between",
                    }}
                  >
                    {t("SV-Check")}
                    <ArrowForwardIosIcon fontSize="small" />
                  </div>
                </ListItemButton>
              </Grid>
            )}
          </Grid>
        </Layout>
        <Grid container justifyContent={"center"}>
          <Grid item xs={12} md={6} lg={5} xl={4} style={{ margin: "8px" }}>
            <Grid container spacing={2} justifyContent={"center"}>
              {auswahlKey !== 0 && (
                <Grid item xs={12} sm={6}>
                  <Button fullWidth style={{ marginRight: "5px", marginBottom: "5px" }} variant="outlined" onClick={() => nextSection(0)}>
                    {t("Zurück zur Übersicht")}
                  </Button>
                </Grid>
              )}
              {auswahlKey !== 0 && auswahlKey !== hmnpunkte.length - 1 && (
                <Grid item xs={12} sm={6}>
                  <Button fullWidth onClick={() => nextSection(Number(auswahlKey) + 1)} variant="contained" color="primary">
                    {t("nächster Abschnitt") + " (" + hmnpunkte[Number(auswahlKey) + 1]?.bez + ")"}
                  </Button>
                </Grid>
              )}
              {(auswahlKey === 0 || auswahlKey === hmnpunkte.length - 1) && (
                <Grid item xs={12} sm={6}>
                  <Button fullWidth variant="contained" color="primary" onClick={() => setPruefen(true)}>
                    {t("Daten Überprüfen")}
                  </Button>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
      </>
    );
  };

  const ueberpruefen = () => {
    return (
      <Fragment>
        {daten?.map((item, index) => {
          return (
            <Layout>
              <CardContent>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography style={{ width: "100%" }} variant="h6" color="primary">
                    {item.bezeichnung}
                  </Typography>
                  <IconButton color="primary" onClick={() => nextSection(index + 1)}>
                    <Edit />
                  </IconButton>
                </div>

                {item.frage.map((element) => {
                  return (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                          }}
                        >
                          {" "}
                          {element.vollstaendig === "1" && element.optional === "0" ? (
                            <IconButton
                              style={{
                                backgroundColor: "unset",
                              }}
                            >
                              <CheckCircleOutlineIcon
                                style={{
                                  color: "rgba(0, 153, 51,0.8)",
                                }}
                              />
                            </IconButton>
                          ) : element.zusatztext ? (
                            <Tooltip
                              componentsProps={{
                                tooltip: {
                                  sx: {
                                    backgroundColor: "#f5f5f9",
                                    // fontSize: "2em",
                                  },
                                },
                              }}
                              title={
                                <div
                                  style={{
                                    textAlign: "left",
                                    backgroundColor: "#f5f5f9",
                                    color: "rgba(0, 0, 0, 0.87)",
                                  }}
                                >
                                  <Typography color="rgba(205, 92, 92,1)" variant="caption">
                                    {element.zusatztext}
                                  </Typography>
                                </div>
                              }
                            >
                              <IconButton
                                style={{
                                  backgroundColor: "unset",
                                }}
                              >
                                <WarningIcon
                                  style={{
                                    color: "rgba(255, 181, 0, 0.8)",
                                  }}
                                />
                              </IconButton>
                            </Tooltip>
                          ) : element.optional === "1" ? (
                            <IconButton
                              style={{
                                backgroundColor: "unset",
                              }}
                            >
                              <Brightness1Icon
                                style={{
                                  color: "rgba(033, 150, 243,0.8)",
                                }}
                              />
                            </IconButton>
                          ) : (
                            <IconButton
                              style={{
                                backgroundColor: "unset",
                              }}
                            >
                              <ErrorOutlineIcon
                                style={{
                                  color: "rgba(205, 92, 92,0.8)",
                                }}
                              />
                            </IconButton>
                          )}
                          <Typography style={{ textAlign: "left" }}>{element.bezeichnung}: </Typography>
                        </div>
                        <div style={{ width: "50%" }}>
                          <Typography style={{ textAlign: "left" }}>{element.antwort} </Typography>
                        </div>
                      </div>

                      {element.antwort === " " && (
                        <IconButton color="primary" onClick={() => nextSection(index + 1, element.key.slice(2))}>
                          <Edit />
                        </IconButton>
                      )}
                    </div>
                  );
                })}
              </CardContent>
            </Layout>
          );
        })}

        {vollstaendig === "1" && (
          <Layout fullWidth>
            <Grid container justifyContent="center">
              <Grid item xs={8} margin={4}>
                <Typography align={"center"}>{t("Vielen Dank für Ihre Mitarbeit!")}</Typography>
              </Grid>

              <Grid item xs={12} sm={10} md={8}>
                <Box px={2}>
                  <Card>
                    <CardContent>
                      <FormControl error={checkedError}>
                        <FormLabel component="legend">Angaben bestätigen</FormLabel>
                        <FormControlLabel
                          control={<Checkbox onClick={handleCheckChange} checked={checked}></Checkbox>}
                          label={t(
                            `Ich versichere, dass ich die Angaben in diesem Online-Formular wahrheitsgemäß, nach bestem Wissen und Gewissen gemacht habe.
           Mir ist bekannt, dass ich für falsche, fehlende Angaben oder für Verschweigen wesentlicher Tatsachen haftbar gemacht werden kann. 
           Sollten sich während meiner Beschäftigungszeit die Verhältnisse ändern, so werde ich meinen Arbeitgeber unverzüglich davon 
           in Kenntnis setzen. Für nachweislich nicht gemeldete Änderungen werde ich zu Schadenersatz herangezogen.`
                          )}
                        />
                      </FormControl>
                    </CardContent>
                  </Card>
                </Box>
                <Typography align={"center"} color="error"></Typography>
              </Grid>
            </Grid>
          </Layout>
        )}
        <Grid item xs={12} md={6} lg={5} xl={4} style={{ margin: "8px" }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Button fullWidth variant="outlined" onClick={() => setPruefen(false)}>
                {t("Zurück zur Übersicht")}
              </Button>
            </Grid>
            <Grid item xs={12} sm={6}>
              {vollstaendig === "1" && (
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    if (checked) {
                      setWarningMsgbox(true);
                    } else {
                      setCheckedError(true);
                    }
                  }}
                  // onClick={() => signatur()}
                >
                  {t("Signatur abgeben")}
                </Button>
              )}
            </Grid>
          </Grid>
        </Grid>
        <div className="ectool-safe-area-top" />
      </Fragment>
    );
  };

  const messageBoxResult = (result) => {
    if (result === "CANCEL") {
      setWarningMsgbox(false);
    } else {
      signatur();
      setWarningMsgbox(false);
    }
  };
  const messageBoxIInitResult = (result) => {
    if (result === "OK") {
      setInitModal(false);
    }
  };

  const zusatzElement = daten?.map((item) => item.frage.filter((element) => element.zusatztext)).flat();

  const WarnungText = () => {
    return (
      <>
        {zusatzElement?.map((i) => {
          return (
            <div style={{ width: "100%", marginTop: "15px" }}>
              <Typography color="primary" style={{ textAlign: "left" }}>
                {i.bezeichnung}:{" "}
              </Typography>
              <div
                style={{
                  textAlign: "left",
                  width: "100%",
                }}
              >
                <Typography>{i.zusatztext} </Typography>
              </div>
            </div>
          );
        })}
      </>
    );
  };
  return (
    <Page>
      {initModal && (
        <MessageBox
          open={initModal}
          handleResponse={messageBoxIInitResult}
          text={[
            <Grid item xs={12}>
              <Typography align={"left"}>
                {t("Bitte beantworten Sie die nachfolgenden Fragen, bis jeder Abschnitt als vollständig gekennzeichnet ist.")}
                <br />
                {t("Falls Sie das Stammformular zu einem späteren Zeitpunkt weiter bearbeiten möchten, werden Ihre Antworten zwischengespeichert.")}
              </Typography>
            </Grid>,
          ]}
          title={t("Hinweis")}
          onClose={() => setInitModal(false)}
        />
      )}
      {warningMsgbox && (
        <MessageBox
          open={warningMsgbox}
          handleResponse={messageBoxResult}
          buttons="OKCANCEL"
          text={[WarnungText()]}
          title={
            zusatzElement.length > 0
              ? t("Bitte bestätigen Sie, dass Sie die folgenden Felder nicht ausgefüllt haben:")
              : "Bitte beachten Sie, dass mit der Bestätigung der Angaben keine weitere Anpassung möglich ist."
          }
          onClose={() => setWarningMsgbox(false)}
        />
      )}
      {pruefen ? ueberpruefen() : zeichne_hauptseite()}
      {plzIsLoading && <FullPageSpinner />}
    </Page>
  );
}
export default Stammformular;
